import { graphql } from "../../common/gql";


export const PRODUCT_RECOMMENDATION_FRAGMENT = graphql(`
    fragment ProductRecommendation on Product {
        id
        name
        slug
        featuredAsset {
            ...Asset
        }
        priceRangeWithTax {
            min
            max
        }
        rrpRange {
            min
            max
        }
        customFields {
            reviewCount
            reviewRating
        }
    }
`);

export const GET_PRODUCT_RECOMMENDATIONS = graphql(`
    query GetProductRecommendations($input: ProductRecommendationsInput!) {
        productRecommendations(input: $input) {
            ...ProductRecommendation
        }
    }
`);
